import Dashboard from './components/Dashboard'
import PermissionDenied from './components/Pages/PermissionDenied'
import Layout from './components/Layout'

/* Авторизация */
import Login from './components/Auth/Login'
import ForgotPassword from './components/Auth/ForgotPassword'
import ResetPassword from './components/Auth/ResetPassword'

/* Пользователи */
import UserForm from "./components/User/Form";
import UserList from "./components/User/List";

import SharingListForm from "./components/SharingList/Form";
import SharingListList from "./components/SharingList/List";

import CircleListForm from "./components/CircleList/Form";
import CircleListList from "./components/CircleList/List";

import EmailSubscriptionsForm from "./components/EmailSubscription/Form"
import EmailSubscriptionsList from "./components/EmailSubscription/List"

/* Администраторы */
import AdministratorList from "./components/Administrator/List";
import AdministratorForm from "./components/Administrator/Form";

import AdminRoleList from "./components/Role/List";
import AdminRoleForm from "./components/Role/Form";

import AdminPermissionList from "./components/Permission/List";
import AdminPermissionForm from "./components/Permission/Form";

/* Артефакты */
import ArtifactList from "./components/Artifact/List";
import ArtifactForm from "./components/Artifact/Form";

import ArtifactTypeList from "./components/Type/List";
import ArtifactTypeForm from "./components/Type/Form";

import ArtifactTagList from "./components/Tag/List";
import ArtifactTagForm from "./components/Tag/Form";

import DocumentTypeList from "./components/Document/List";
import DocumentTypeForm from "./components/Document/Form";

import ArtifactOccasionList from "./components/Occasion/List";
import ArtifactOccasionForm from "./components/Occasion/Form";

import ArtifactCountryList from "./components/Country/List";
import ArtifactCountryForm from "./components/Country/Form";

import ArtifactCenturyList from "./components/Century/List";
import ArtifactCenturyForm from "./components/Century/Form";

import ArtifactValueList from "./components/Value/List";
import ArtifactValueForm from "./components/Value/Form";

import ArtifactUnitList from "./components/Unit/List";
import ArtifactUnitForm from "./components/Unit/Form";

import ArtifactValuationList from "./components/Valuation/List";
import ArtifactValuationForm from "./components/Valuation/Form";

import ContentList from "./components/Content/List";
import ContentForm from "./components/Content/Form";

import SubscriptionList from "./components/Subscription/List";
import SubscriptionForm from "./components/Subscription/Form";

import SubscriptionGiftList from "./components/SubscriptionGift/List";
import SubscriptionGiftForm from "./components/SubscriptionGift/Form";

import SubscriptionPlanList from "./components/SubscriptionPlan/List";
import SubscriptionPlanForm from "./components/SubscriptionPlan/Form";

import SubscriptionPlanDescriptionList from "./components/SubscriptionPlanDescription/List";
import SubscriptionPlanDescriptionForm from "./components/SubscriptionPlanDescription/Form";

import SubscriptionPlanPermissionList from "./components/SubscriptionPlanPermission/List";
import SubscriptionPlanPermissionForm from "./components/SubscriptionPlanPermission/Form";

import TransactionList from "./components/Transaction/List";
import TransactionForm from "./components/Transaction/Form";

import ArtifactViolationReportList from "./components/ViolationReports/ArtifactViolationReportList";

import { store } from './store'

/* Консьерж сервис */
import ConciergeServiceList from './components/ConciergeService/List'
import ConciergeServiceForm from './components/ConciergeService/Form'

/* Блог */
import BlogCategoryList from './components/Blog/Category/List'
import BlogCategoryForm from './components/Blog/Category/Form'

import BlogPostList from './components/Blog/Post/List'
import BlogPostForm from './components/Blog/Post/Form'

/* Marketing */
import PromoCodeList from './components/Marketing/PromoCode/List'
import PromoCodeForm from './components/Marketing/PromoCode/Form'

import PartnerPromoCodeList from './components/Marketing/PartnerPromoCode/List'
import PartnerPromoCodeForm from './components/Marketing/PartnerPromoCode/Form'

import HomePage from './components/Homepage/Form'
import FAQPage from './components/FAQ/Form'
import ForMomPage from './components/ForMom/Form'
import ArtiProPage from './components/ArtiPro/Form'
import HowKnow from "./components/User/HowKnow.vue";

/* Company */
import CompanyList from './components/Company/Company/List'
import CompanyForm from './components/Company/Company/Form'

import CompanyRequestList from './components/Company/CompanyRequest/List'
import CompanyRequestForm from './components/Company/CompanyRequest/Form'

import ForProfessionalsForm from './components/Company/ForProfessionals/Form'
import QrCodeList from "./components/Marketing/QrCode/QrCodeList.vue";
import QrCodeForm from "./components/Marketing/QrCode/QrCodeForm.vue";
import KomenForm from "./components/Komen/KomenForm.vue";
import ArtiProMembershipList from "./components/ArtiProMembership/ArtiProMembershipList.vue";
import ArtiProMembershipForm from "./components/ArtiProMembership/ArtiProMembershipForm.vue";

/* Brain health */
import BrainHealthList from "./components/BrainHealth/List.vue";



const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
        return
    }
    next('/')
}
const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next()
        return
    }
    next('/login')
}

export const routes = [

    // Авторизация
    { path: '/login', component: Login, name: 'auth.login', beforeEnter: ifNotAuthenticated },
    { path: '/forgot-password', component: ForgotPassword, name: 'auth.forgot_password', beforeEnter: ifNotAuthenticated },
    { path: '/password/reset/:token', component: ResetPassword, name: 'auth.reset_password', beforeEnter: ifNotAuthenticated, props: true },


    // Панель управления
    { path: '/', component: Layout, beforeEnter: ifAuthenticated, children: [
            { path: '', component: Dashboard, name: 'dashboard' },
            { path: '/permission-denied', component: PermissionDenied, name: 'permission.denied' },

            { path: 'homepage', component: HomePage, name: 'homepage' },
            { path: 'faq', component: FAQPage, name: 'faq' },
            { path: 'for-mom', component: ForMomPage, name: 'forMom' },
            { path: 'arti-pro', component: ArtiProPage, name: 'artiPro' },
            { path: 'komen', component: KomenForm, name: 'komen' },

            // Партнерские промокоды
            { path: 'partner-promo-code', component: PartnerPromoCodeList, name: 'partner_promo_code' },
            { path: 'partner-promo-code/create', component: PartnerPromoCodeForm, name: 'partner_promo_code.create' },
            { path: 'partner-promo-code/:id/edit', component: PartnerPromoCodeForm, name: 'partner_promo_code.edit' },

            // Промокоды
            { path: 'promo-code', component: PromoCodeList, name: 'promo_code' },
            { path: 'promo-code/create', component: PromoCodeForm, name: 'promo_code.create' },
            { path: 'promo-code/:id/edit', component: PromoCodeForm, name: 'promo_code.edit' },

            // QR коды
            { path: 'qr-code', component: QrCodeList, name: 'qr_code' },
            { path: 'qr-code/create', component: QrCodeForm, name: 'qr_code.create' },
            { path: 'qr-code/:id/edit', component: QrCodeForm, name: 'qr_code.edit' },

            // Пользователи
            { path: 'user', component: UserList, name: 'user' },
            { path: 'user/create', component: UserForm, name: 'user.create' },
            { path: 'user/:id/edit', component: UserForm, name: 'user.edit' },

            // Статистика "Откуда узнали" How know
            { path: 'how-know', component: HowKnow, name: 'how_know' },

            // Шеринг списки
            { path: 'sharing-list', component: SharingListList, name: 'sharing_list' },
            { path: 'sharing-list/create', component: SharingListForm, name: 'sharing_list.create' },
            { path: 'sharing-list/:id/edit', component: SharingListForm, name: 'sharing_list.edit' },

            // Списки кругов
            { path: 'circle-list', component: CircleListList, name: 'circle_list' },
            { path: 'circle-list/create', component: CircleListForm, name: 'circle_list.create' },
            { path: 'circle-list/:id/edit', component: CircleListForm, name: 'circle_list.edit' },

            // Списки полписок
            { path: 'email-subscriptions-list', component: EmailSubscriptionsList, name: 'email_subscriptions_list' },
            { path: 'email-subscriptions-list/create', component: EmailSubscriptionsForm, name: 'email_subscriptions_list.create' },
            { path: 'email-subscriptions-list/:id/edit', component: EmailSubscriptionsForm, name: 'email_subscriptions_list.edit' },

            // Администраторы
            { path: 'administrator', component: AdministratorList, name: 'administrator' },
            { path: 'administrator/create', component: AdministratorForm, name: 'administrator.create' },
            { path: 'administrator/:id/edit', component: AdministratorForm, name: 'administrator.edit' },

            // Роли администраторов
            { path: 'administrator-roles', component: AdminRoleList, name: 'administrator.role' },
            { path: 'administrator-roles/create', component: AdminRoleForm, name: 'administrator.role.create' },
            { path: 'administrator-roles/:id/edit', component: AdminRoleForm, name: 'administrator.role.edit' },

            // Разрешения администраторов
            { path: 'administrator-permission', component: AdminPermissionList, name: 'administrator.permission' },
            { path: 'administrator-permission/create', component: AdminPermissionForm, name: 'administrator.permission.create' },
            { path: 'administrator-permission/:id/edit', component: AdminPermissionForm, name: 'administrator.permission.edit' },

            // Артефакты
            { path: 'artifact', component: ArtifactList, name: 'artifact' },
            { path: 'artifact/create', component: ArtifactForm, name: 'artifact.create' },
            { path: 'artifact/:id/edit', component: ArtifactForm, name: 'artifact.edit' },

            // Типы артефактов
            { path: 'type', component: ArtifactTypeList, name: 'type' },
            { path: 'type/create', component: ArtifactTypeForm, name: 'type.create' },
            { path: 'type/:id/edit', component: ArtifactTypeForm, name: 'type.edit' },

            // Тэги артефактов
            { path: 'tag', component: ArtifactTagList, name: 'tag' },
            { path: 'tag/create', component: ArtifactTagForm, name: 'tag.create' },
            { path: 'tag/:id/edit', component: ArtifactTagForm, name: 'tag.edit' },

            // Типы документов артефактов
            { path: 'document', component: DocumentTypeList, name: 'document' },
            { path: 'document/create', component: DocumentTypeForm, name: 'document.create' },
            { path: 'document/:id/edit', component: DocumentTypeForm, name: 'document.edit' },

            // Типы ассоциаций артефактов
            { path: 'occasion', component: ArtifactOccasionList, name: 'occasion' },
            { path: 'occasion/create', component: ArtifactOccasionForm, name: 'occasion.create' },
            { path: 'occasion/:id/edit', component: ArtifactOccasionForm, name: 'occasion.edit' },

            // Страны артефактов
            { path: 'country', component: ArtifactCountryList, name: 'country' },
            { path: 'country/create', component: ArtifactCountryForm, name: 'country.create' },
            { path: 'country/:id/edit', component: ArtifactCountryForm, name: 'country.edit' },

            // Века артефактов
            { path: 'century', component: ArtifactCenturyList, name: 'century' },
            { path: 'century/create', component: ArtifactCenturyForm, name: 'century.create' },
            { path: 'century/:id/edit', component: ArtifactCenturyForm, name: 'century.edit' },

            // Типы размеров артефактов
            { path: 'unit', component: ArtifactUnitList, name: 'unit' },
            { path: 'unit/create', component: ArtifactUnitForm, name: 'unit.create' },
            { path: 'unit/:id/edit', component: ArtifactUnitForm, name: 'unit.edit' },

            // Типы стоимости артефактов
            { path: 'value', component: ArtifactValueList, name: 'value' },
            { path: 'value/create', component: ArtifactValueForm, name: 'value.create' },
            { path: 'value/:id/edit', component: ArtifactValueForm, name: 'value.edit' },

            // Оценка артефактов
            { path: 'valuation', component: ArtifactValuationList, name: 'valuation' },
            { path: 'valuation/create', component: ArtifactValuationForm, name: 'valuation.create' },
            { path: 'valuation/:id/edit', component: ArtifactValuationForm, name: 'valuation.edit' },

            // Жалобы на артефакты
            { path: 'violation-reports', component: ArtifactViolationReportList, name: 'violation-reports' },

            // Контент
            { path: 'content', component: ContentList, name: 'content' },
            { path: 'content/create', component: ContentForm, name: 'content.create' },
            { path: 'content/:id/edit', component: ContentForm, name: 'content.edit' },

            // Подписка ARTIPro
            { path: 'artiProMembership', component: ArtiProMembershipList, name: 'artiProMembership' },
            { path: 'artiProMembership/create', component: ArtiProMembershipForm, name: 'artiProMembership.create' },
            { path: 'artiProMembership/:id/edit', component: ArtiProMembershipForm, name: 'artiProMembership.edit' },

            // Подписка
            { path: 'subscription', component: SubscriptionList, name: 'subscription' },
            { path: 'subscription/create', component: SubscriptionForm, name: 'subscription.create' },
            { path: 'subscription/:id/edit', component: SubscriptionForm, name: 'subscription.edit' },

            // Подарочная подписка
            { path: 'subscription-gift', component: SubscriptionGiftList, name: 'subscription_gift' },
            { path: 'subscription-gift/create', component: SubscriptionGiftForm, name: 'subscription_gift.create' },
            { path: 'subscription-gift/:id/edit', component: SubscriptionGiftForm, name: 'subscription_gift.edit' },

            // Тарифные планы
            { path: 'plan', component: SubscriptionPlanList, name: 'plan' },
            { path: 'plan/create', component: SubscriptionPlanForm, name: 'plan.create' },
            { path: 'plan/:id/edit', component: SubscriptionPlanForm, name: 'plan.edit' },

            // Описание тарифных планов
            { path: 'plan-description', component: SubscriptionPlanDescriptionList, name: 'plan_description' },
            { path: 'plan-description/create', component: SubscriptionPlanDescriptionForm, name: 'plan_description.create' },
            { path: 'plan-description/:id/edit', component: SubscriptionPlanDescriptionForm, name: 'plan_description.edit' },

            // Описание тарифных планов
            { path: 'plan-permission', component: SubscriptionPlanPermissionList, name: 'plan_permission' },
            { path: 'plan-permission/create', component: SubscriptionPlanPermissionForm, name: 'plan_permission.create' },
            { path: 'plan-permission/:id/edit', component: SubscriptionPlanPermissionForm, name: 'plan_permission.edit' },

            // Транзакции
            { path: 'transaction', component: TransactionList, name: 'transaction' },
            { path: 'transaction/create', component: TransactionForm, name: 'transaction.create' },
            { path: 'transaction/:id/edit', component: TransactionForm, name: 'transaction.edit' },

            // Консьерж сервис
            { path: 'concierge-service', component: ConciergeServiceList, name: 'concierge_service' },
            { path: 'concierge-service/create', component: ConciergeServiceForm, name: 'concierge_service.create' },
            { path: 'concierge-service/:id/edit', component: ConciergeServiceForm, name: 'concierge_service.edit' },

            // Категория блога
            { path: 'blog-category', component: BlogCategoryList, name: 'blog_category' },
            { path: 'blog-category/create', component: BlogCategoryForm, name: 'blog_category.create' },
            { path: 'blog-category/:id/edit', component: BlogCategoryForm, name: 'blog_category.edit' },

            // Пост блога
            { path: 'blog-post', component: BlogPostList, name: 'blog_post' },
            { path: 'blog-post/create', component: BlogPostForm, name: 'blog_post.create' },
            { path: 'blog-post/:id/edit', component: BlogPostForm, name: 'blog_post.edit' },

            // Компании
            { path: 'company', component: CompanyList, name: 'company' },
            { path: 'company/create', component: CompanyForm, name: 'company.create' },
            { path: 'company/:id/edit', component: CompanyForm, name: 'company.edit' },

            // Запросы компаний
            { path: 'company-request', component: CompanyRequestList, name: 'company.request' },
            { path: 'company-request/create', component: CompanyRequestForm, name: 'company.request.create' },
            { path: 'company-request/:id/edit', component: CompanyRequestForm, name: 'company.request.edit' },

            { path: 'for-professionals-page', component: ForProfessionalsForm, name: 'forProfessionals' },

            // Brain health
            { path: 'brain-health', component: BrainHealthList, name: 'brain-health'}
        ]
    },
]
